import React, { Fragment, useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import {
  EmpMailStatus,
  EmployeeLoader,
  ExportmemberData,
  GetCorporateEmployeeList,
} from "../../Redux/Action/EmployeeAction";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
// import icon
import { AiOutlineMail } from "react-icons/ai";
import { RiSearch2Line } from "react-icons/ri";
import LimitArrow from "../../images/LimitArrow.svg";
import { Menu, Transition } from "@headlessui/react";
import Loader from "../../component/Admin/Loader";
import UseOutsideClick from "../../component/Admin/UseOutsideClick";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calender from "../../images/Doctor/calender.png";
import ClearFilter from "../../images/clear filter icon.png";
import VfsBranchLayout from "../../component/layout/VfsBranchLayout/VfsBranchLayout";
import { ExportRangeSelectModel } from "../../component/Modal/AdminModal/ExportRangeSelectModel";
import ExportModel from "../../component/common/ExportModel";

const CorporateEmployee = () => {
  const location = useLocation();
  const history = useNavigate();
  const [selectpage, setselectpage] = useState("");

  const itemsPerPageOptions = [
    { value: "10", label: "10", id: 1 },
    { value: "25", label: "25", id: 2 },
    { value: "50", label: "50", id: 3 },
  ];

  const dispatch = useDispatch();
  const user = localStorage.getItem("Admin");
  const newcorporate = JSON.parse(user);

  useEffect(() => {
    searchParams.delete("search");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.search;
    delete object.startDate;
    delete object.endDate;
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, { ...object })
    );
    dispatch(EmployeeLoader())
  }, []);

  const Employeelist = useSelector(
    (state) => state?.Employelists?.CorporateEmployeList?.data
  );

  const [Itemperpage, setItemperpage] = useState("");
  const [page, setpage] = useState("");
  const pageCount = Math.ceil(Number(Employeelist?.count) / Number(page));

  useEffect(() => {
    if (pageCount && pageCount !== Infinity) {
      setItemperpage(pageCount);
    }
  }, [Employeelist]);

  useEffect(() => {
    setpage(itemsPerPageOptions[0]?.value);
  }, []);

  // for select page data
  const onselectedpage = (item) => {
    setpage(item.value);

    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });

      setpage(item.value);
      setselectpage(0)
      history({
        pathname: "/vfs-branch/member",
        search:
          "?" +
          new URLSearchParams({ ...object, limit: item.value, page: 1 }).toString(),
      });
    } else {
      history({
        pathname: "/vfs-branch/member",
        search: `?limit=${item.value}`,
      });
    }
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, {
        ...object,
        limit: item.value,
        page: 1
      })
    );
    dispatch(EmployeeLoader())

  };

  // for pagination
  const handleFirstPage = () => {
    setselectpage(0);
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
      history({
        pathname: "/vfs-branch/member",
        search: "?" + new URLSearchParams({ ...object, page: 1 }).toString(),
      });
    } else {
      history({
        pathname: "/vfs-branch/member",
        search: `?page=1`,
      });
    }
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, {
        ...object,
        page: 1,
      })
    );
    dispatch(EmployeeLoader())

  };
  const handleLastPage = () => {
    const lastPage = pageCount - 1;
    setselectpage(lastPage);
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
      history({
        pathname: "/vfs-branch/member",
        search:
          "?" +
          new URLSearchParams({ ...object, page: lastPage + 1 }).toString(),
      });
    } else {
      history({
        pathname: "/vfs-branch/member",
        search: `?page=${lastPage + 1}`,
      });
    }
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, {
        ...object,
        page: lastPage + 1,
      })
    );
    dispatch(EmployeeLoader())

  };
  const handlePageChange = (selected) => {
    setselectpage(selected.selected);
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });

      history({
        pathname: "/vfs-branch/member",
        search:
          "?" +
          new URLSearchParams({
            ...object,
            page: selected.selected + 1,
          }).toString(),
      });
    } else {
      history({
        pathname: "/vfs-branch/member",
        search: `?page=${selected.selected + 1}`,
      });
    }
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, {
        ...object,
        page: selected.selected + 1,
      })
    );
    dispatch(EmployeeLoader())

  };

  //for search filter
  const [Search, setSearch] = useState("");

  const submitsearch = (e) => {
    e?.preventDefault();
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
      delete (object.page);
      history({
        pathname: "/vfs-branch/member",
        search:
          "?" + new URLSearchParams({ ...object, search: Search }).toString(),
      });
    } else {
      history({
        pathname: "/vfs-branch/member",
        search: `?search=${Search}`,
      });
    }
    dispatch(
      GetCorporateEmployeeList(newcorporate?.data?.corporateID, {
        ...object,
        search: Search,
      })
    );
    setselectpage(object.page = 0);
    dispatch(EmployeeLoader())

  };



  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    const param = searchParams.get("search");
    if (param) {
      searchParams.delete("search");
      setSearchParams(searchParams);
    }
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete (object.search)
    delete (object.page)
    history({
      pathname: "/vfs-branch/member",
      search:
        "?" +
        new URLSearchParams({
          ...object
        }).toString(),
    });
    dispatch(GetCorporateEmployeeList(newcorporate?.data?.corporateID, object));
    setselectpage(object.page = 0);
    dispatch(EmployeeLoader())

  };

  // for mail 
  const handelMail = (id) => {
    dispatch(EmpMailStatus(id, newcorporate?.data?.corporateID,));
    dispatch(EmployeeLoader())
  }


  useEffect(() => {
    const newlimit = searchParams.get("limit");
    if (newlimit?.length > 0) {
      setpage(newlimit);
    }
  }, []);

  useEffect(() => {
    const newpage = searchParams.get("page");
    if (newpage?.length > 0 && newpage !== null) {
      setselectpage(newpage - 1);
    }
  }, [searchParams]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //for pagination
  const reactPaginate = {
    previousLabel: "<",
    nextLabel: ">",
    breakLabel: "",
    pageCount: Itemperpage,
    onPageChange: handlePageChange,
    containerClassName: "pagination",
    previousLinkClassName: "pagination__link",
    nextLinkClassName: "pagination__link",
    disabledClassName: "pagination__link--disabled",
    activeClassName: "pagination__link--active",
    forcePage: selectpage,
  };

  const loader = useSelector((state) => state?.Employelists?.employeeloader)

  const [showdelete, setshowdelete] = useState(false);
  const [selectionRange, setSelectionRange] = useState(null);
  useEffect(() => {
    if (selectionRange?.startDate || selectionRange?.endDate) {
      setshowdelete(true);
    } else {
      setshowdelete(false);
    }
  }, [selectionRange]);

  const [openCalender, setopenCalender] = useState(false);
  const [unixstartDate, setUnixStartDate] = useState(new Date(new Date().setUTCHours(0, 0, 0, 0))?.getTime());
  const [unixendDate, setUnixendDate] = useState(new Date(new Date().setUTCHours(23, 59, 59, 999))?.getTime());
  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (openCalender) {
      setopenCalender(false);
    }
  });

  const handleSelection = (range) => {
    setSelectionRange({
      startDate: range.selection.startDate,
      endDate: range.selection.endDate,
      key: "selection",
    });
  
    const startDateText = formatDate(range.selection.startDate);
    const endDateText = formatDate(range.selection.endDate);
  
    let unix_timestamp = new Date(
      new Date(startDateText).setUTCHours(23, 59, 59, 999)
    ).getTime();
    let unix_timestamp1 = Math.floor(
      new Date(endDateText).getTime() + 86400000
    );
  
    setUnixStartDate(unix_timestamp);
    setUnixendDate(unix_timestamp1);
  
    const sds = location.search.slice(1).split("&");
    let object = {};
  
    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");
        if (key !== "page") {
          object[key] = value;
        }
      });
    }
  
    const updatedParams = {
      ...object,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      page: 1, //  Force page 1
    };
  
    history({
      pathname: "/vfs-branch/member",
      search: "?" + new URLSearchParams(updatedParams).toString(),
    });
  
    dispatch(GetCorporateEmployeeList(newcorporate?.data?.corporateID, updatedParams));
    setselectpage(0); //  Optional: Reset UI pagination
    dispatch(EmployeeLoader())

  };
  
  const handlecorporatedelete = () => {
    searchParams.delete("startDate");
    searchParams.delete("endDate");

    setSelectionRange(null);
    setopenCalender(false);
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.startDate;
    delete object.endDate;
    dispatch(GetCorporateEmployeeList(newcorporate?.data?.corporateID, { ...object }));
    dispatch(EmployeeLoader())

  };

  function formattedStartDate(d) {
    let month = String(d?.getMonth() + 1);
    let day = String(d?.getDate());
    const year = String(d?.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}/${month}/${year}`;
  }

  // export data
  const [showDateWarning, setShowDateWarning] = useState(false);
  const [showExportModel,setShowExportModel] = useState(false);

  const handleExportData = (enteredEmail) => {
    if (!selectionRange) {
      setShowDateWarning(true);
      return; // Stop export
    }
    const token=localStorage.getItem("Admin");
    const userData = JSON.parse(token);
    const userEmail = userData?.data?.email;
    const sds = location.search.slice(1).split("&");
    let object = {};

    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");

        if (object[key]) {
          if (Array.isArray(object[key])) {
            object[key].push(value);
          } else {
            object[key] = [object[key], value];
          }
        } else {
          object[key] = value;
        }
      });
    }

    // Ensure 'corporateID' is always an array
    if (object.corporateID && !Array.isArray(object.corporateID)) {
      object.corporateID = [object.corporateID];
    }

    // Remove unwanted query params
    delete object.page;
    delete object.limit;
     if (userEmail) {
        dispatch(ExportmemberData({ ...object, email: userEmail }));
        dispatch(EmployeeLoader());
      } else {
        if (enteredEmail) {
          dispatch(ExportmemberData({ ...object, email: enteredEmail }));
          dispatch(EmployeeLoader());
        } else {
          setShowExportModel(true);
        }
      }
  };
  return (
    <>
      {loader && (
        <div>
          <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-[999] bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <VfsBranchLayout>
        <div className="flex flex-col h-[calc(100vh-58px)] px-5 py-5 2xl:justify-between">
          {/* --------------------------------------------Search Bar---------------------------------------------------------- */}
          <div className="bg-white p-4 mb-5 rounded-lg  w-full">
            <div className=" flex-wrap items-center justify-between gap-3 md:flex md:gap-0">
              <div className="relative flex items-center gap-3">
                <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                  <RiSearch2Line className="w-6 h-6" />
                </div>

                <form
                  onSubmit={(e) => {
                    e?.preventDefault();
                    if (Search.trim() !== "") {
                      submitsearch(e);
                    }
                  }}
                >
                  <input
                    className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[350px] placeholder:text-[#47505F]  placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                    placeholder="Search By Member Name ,Email, Contact No."
                    value={Search}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setSearch(inputValue);
                      if (inputValue.trim() === "") {
                        removeQueryParams();
                      }
                    }}
                  ></input>
                </form>
                <p className="text-sm font-semibold">
                  Total Member : {Employeelist && Employeelist?.count}
                </p>
              </div>
              <div className=" flex items-center md:justify-end rounded-[8px] gap-4  mt-3 xl:mt-0">
                {showdelete && (
                  <div className="flex gap-3 z-10">
                    <button
                      className="bg-[#FCDD00] py-1 px-3  rounded-[4px] del-tooltip"
                      onClick={handlecorporatedelete}
                    >
                      <img src={ClearFilter} alt="new"></img>
                      <span className="del-tooltiptext">Clear Filter</span>
                    </button>
                  </div>
                )}

                <div className=" relative ">
                  <button
                    className=" bg-[#fae006] flex px-4 rounded-[8px] py-2 font-medium"
                    onClick={() => setopenCalender(!openCalender)}
                  >
                    <img
                      src={calender}
                      className="mr-[12px]"
                      alt="calenderimg"
                    ></img>
                    {selectionRange
                      ? `${formattedStartDate(
                          selectionRange.startDate
                        )} - ${formattedStartDate(selectionRange.endDate)}`
                      : "Select Date"}
                  </button>
                  {openCalender && (
                    <div className=" absolute md:right-0 z-50" ref={ref}>
                      <DateRangePicker
                        ranges={[
                          selectionRange || {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: "selection",
                          },
                        ]}
                        onChange={handleSelection}
                        rangeColors={["#FCDD00"]}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        popperProps={{
                          strategy: "fixed",
                        }}
                        direction="horizontal"
                      />
                    </div>
                  )}
                </div>
                {Employeelist?.employeeData?.length > 0 && (
                  <button
                    className=" bg-[#fae006] flex px-4 rounded-[8px] py-2 font-medium"
                    onClick={() => handleExportData()}
                  >
                    Export
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* --------------------------------------------Content Table------------------------------------------------------- */}
          <div className="flex-1 overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
            {Employeelist?.employeeData?.length === 0 ? (
              <div className="flex justify-center items-center h-full">
                <p className="font-Roboto text-xl ">
                  No Member Details Available.
                </p>
              </div>
            ) : (
              <table className="corporate-table w-[100%]  text-left font-Poppins">
                <thead>
                  <tr className="">
                    {/* <th><div className="pl-[40px] py-3 xl:py-5 min-w-[320px]">Corporate Name</div></th> */}
                    <th>
                      <div className="pl-[40px] py-3 xl:py-5 min-w-[200px]">
                        Member Name
                      </div>
                    </th>
                    <th>
                      <div className="min-w-[230px]">Email Id</div>
                    </th>
                    <th>
                      <div className="min-w-[160px]">Contact No.</div>
                    </th>
                    <th>
                      <div className="min-w-[120px]">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Employeelist?.employeeData?.map((user, index) => (
                    <tr key={index}>
                      {user?.name?.length > 30 ? (
                        <td className="pl-[40px] py-2 xl:py-4 h-[46px]">
                          <div className="tooltip ">
                            {`${user?.name?.substring(0, 30)}...`}
                            <span className="tooltiptext">{user.name}</span>
                          </div>
                        </td>
                      ) : (
                        <td className="pl-[40px] py-2 xl:py-4 h-[46px]">
                          <div className="">{user.name}</div>
                        </td>
                      )}

                      {user?.email?.length > 35 ? (
                        <td>
                          <div className="tooltip">
                            {`${user?.email?.substring(0, 35)}...`}
                            <span className="tooltiptext">{user.email}</span>
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div>{user.email}</div>
                        </td>
                      )}

                      <td>{user.contact}</td>

                      <td>
                        <div className="flex ml-3">
                          {/* mail btn  */}
                          <div>
                            {user?.status === true ? (
                              <span className="text-xl">
                                <AiOutlineMail
                                  className="cursor-pointer"
                                  onClick={() => handelMail(user?._id)}
                                />
                              </span>
                            ) : (
                              <div className="tooltip">
                                <span className="text-xl">
                                  <AiOutlineMail className="cursor-pointer" />
                                </span>
                                <span className="tooltiptext">
                                  {user.status && user.status !== true
                                    ? "This Corporate status has been deactivated."
                                    : "This Member status has been deactivated."}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* <ToastContainer /> */}
          </div>
          {/* --------------------------------------------Footer---------------------------------------------------------- */}
          {Employeelist?.employeeData?.length > 0 && (
            <div className="sticky bottom-0 mt-3 bg-white footer-content">
              <div className="md:flex justify-between items-center">
                <div className="flex gap-2 items-center">
                  <p className="capitalize">View</p>
                  <div className="">
                    <Menu as="div" className="relative text-left">
                      <div>
                        <Menu.Button className="flex px-[10px] ml-[24px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                          <p className="text-[#47505F] font-medium font-[poppins]">
                            {page}
                          </p>
                          <img src={LimitArrow} alt="LimitArrow" />
                        </Menu.Button>
                      </div>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                          {itemsPerPageOptions?.map((e) => (
                            <div key={e?.id}>
                              <Menu.Item>
                                {({ active }) => (
                                  <p
                                    className={classNames(
                                      active
                                        ? "bg-[#FFFCE1] text-[#1A1A1A]"
                                        : "",
                                      "block px-2 py-2 text-sm cursor-pointer"
                                    )}
                                    onClick={() => onselectedpage(e)}
                                  >
                                    {e?.value}
                                  </p>
                                )}
                              </Menu.Item>
                            </div>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
                {/* --------------------------------------------Footer Pagination---------------------------------------------------------- */}

                <div className="flex items-center mt-3 md:mt-0">
                  <button
                    className="cursor-pointer text-[#000] text-base border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleFirstPage}
                  >
                    &lt;&lt;
                  </button>
                  <div className="hidden md:block">
                    <ReactPaginate
                      {...reactPaginate}
                      breakLabel="..."
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                    />
                  </div>
                  <div className="md:hidden">
                    <ReactPaginate
                      {...reactPaginate}
                      marginPagesDisplayed={0}
                      pageRangeDisplayed={1}
                    />
                  </div>
                  <button
                    className="cursor-pointer text-[#000] text-base border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleLastPage}
                  >
                    &gt;&gt;
                  </button>
                </div>
              </div>
            </div>
          )}
          {showDateWarning && (
            <ExportRangeSelectModel
              openModel={showDateWarning}
              onClose={() => setShowDateWarning(false)}
            />
          )}
          {showExportModel && (
            <ExportModel
              isOpen={showExportModel}
              onClose={() => setShowExportModel(false)}
              exportData={handleExportData}
            />
          )}
        </div>
      </VfsBranchLayout>
    </>
  );
};

export default CorporateEmployee;
